module.exports = __webpack_public_path__ + "img/Schlacht_und_Untersuchungsgruppe.60c37875.svg";